<template>
  <aside class="document-page">
    <DocumentPageTitle :title="'District Vision: ' + formattedPageTitle" />

    <section
      class="document-section"
    >
      <div>
        <template
          v-for="(question, index) in section.questions"
          :key="index"
        >
          <h3>{{ question.title }}</h3>

          <div v-html="question.content" />
        </template>
      </div>
    </section>
  </aside>
</template>

<script setup>

import { DocumentPageTitle } from '@/components/plan-document';
import { computed } from 'vue';

const props = defineProps({
  section: {
    type: Array,
    default: () => [],
  },
});

// The first questions already includes 'District Vision' but it needs to be consistent with the other ones
const formattedPageTitle = computed(() => {
  return (props.section.heading === 'District Vision 2050') ? '2050' : props.section.heading;
});

</script>
